import React, { useState, useEffect } from 'react';

function ProfileCard({ children, customClass }) {
  
  return (
    <div className={`flex flex-col justify-between items-start md:p-[1.5rem] p-3 bg-white rounded-lg shadow-standard ${customClass}`}>
      {children}
    </div>
  );
}

export default ProfileCard;
